import { Heading, Stack, type StackProps } from '@react/chakra';

import type { JSX, ReactNode } from 'react';

type TContent =
  | string
  | {
      text: string;
      icon: ReactNode;
    };

interface IContentProps extends Omit<StackProps, 'content'> {
  title: string;
  content?: TContent | TContent[];
}

export function Content({
  title,
  content = [],
  ...props
}: IContentProps): JSX.Element {
  if (!Array.isArray(content)) {
    content = [content];
  }

  return (
    <Stack gap={10} {...props}>
      <Heading size='2xl'>{title}</Heading>
      <Stack gap={5}>
        {content.map((c) => {
          if (typeof c === 'string') {
            return (
              <Heading key={c} size='md' variant='sub'>
                {c}
              </Heading>
            );
          }

          const { text, icon } = c;

          return (
            <Heading variant='sub' size='md' key={text}>
              {text}
              {icon}
            </Heading>
          );
        })}
      </Stack>
    </Stack>
  );
}
